import {
  ClockCircleOutlined,
  MailTwoTone,
  PhoneTwoTone,
} from '@ant-design/icons';
import { Flex, Timeline, Typography } from 'antd';
import React, { useMemo } from 'react';
import { getWorkflowItemIcon } from 'utils/workflow';
import CallAction from '../containers/CustomerCenter/Companies/RunSequenceDrawer/CallAction';
import EmailAction from '../containers/CustomerCenter/Companies/RunSequenceDrawer/EmailAction';
import WaitAction from '../containers/CustomerCenter/Companies/RunSequenceDrawer/WaitAction';

function ActionTimeline({ trigger, actions, onFormsChange }) {
  // const getItemIcon = (actionCode) => {
  //   switch (actionCode) {
  //   case 'email':
  //     return wrap(<MailTwoTone className="text-xs" />, {
  //       backgroundColor: '#E6F7FF',
  //       borderColor: '#1890FF',
  //     });
  //   case 'wait':
  //   case 'wait_minutes':
  //   case 'wait_business_days':
  //     return wrap(<ClockCircleOutlined className="text-xs" />, {
  //       borderColor: '#666B71',
  //       color: '#666B71',
  //     });
  //   case 'call':
  //     return wrap(<PhoneTwoTone twoToneColor="orange" />, {
  //       backgroundColor: '#FFF1E6',
  //       borderColor: '#FFA940',
  //     });
  //   default:
  //     return null;
  //   }

  //   function wrap(icon, style) {
  //     return (
  //       <Flex
  //         align="center"
  //         justify="center"
  //         className="w-[22px] h-[22px]"
  //         style={{
  //           borderWidth: '0.5px',
  //           borderStyle: 'solid',
  //           borderRadius: '2.5px',
  //           ...style,
  //         }}
  //       >
  //         {icon}
  //       </Flex>
  //     );
  //   }
  // };

  const timelineItems = useMemo(() => {
    const actionItems = actions.map((action) => ({
      dot: getWorkflowItemIcon(action),
      children: renderActionComponent(action, onFormsChange),
    }));
    if (trigger?.auto_trigger) {
      return [
        {
          dot: getWorkflowItemIcon('trigger'),
          children: <Typography.Text className="capitalize">{ trigger.code.replace(/_/g, ' ') }</Typography.Text>,
        },
        ...actionItems,
      ];
    }
    return actionItems;
  }, [actions, trigger]);

  return (
    <Timeline items={timelineItems} />
  );
}

const renderActionComponent = (action, onFormsChange) => {
  switch (action.code) {
  case 'email':
    return (
      <EmailAction
        action={action}
        onFormsChange={onFormsChange}
      />
    );
  case 'wait':
  case 'wait_business_days':
  case 'wait_minutes':
    return (
      <WaitAction
        action={action}
        onFormsChange={onFormsChange}
      />
    );
  case 'call':
    return (
      <CallAction
        action={action}
        onFormsChange={onFormsChange}
      />
    );

  case 'trigger':
    return (
      <Typography.Text>Trigger</Typography.Text>
    );
  default:
    return (
      <EmailAction
        action={action}
        onFormsChange={onFormsChange}
      />
    );
  }
};

export default ActionTimeline;
